import { createContext, useContext, useEffect, useState } from 'react';
import { getData } from '../services/api';
import { API_ENDPOINTS } from '../constant/API_ENDPOINTS';

const InitialFetchContext = createContext();

export const NavBarDatahProvider = ({ children }) => {
    const [blogs, setBlogs] = useState(null);
    const [categories, setCategories] = useState(null);
    const [navbarCategories, setNavbarCategories] = useState(null);
    const [svgContent, setSvgContent] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const navBarData = async () => {
            setLoading(true);
            try {
                const [
                    blogsResponse,
                    categoriesResponse,
                    navbarCategoriesResponse,
                ] = await Promise.allSettled([
                    getData(API_ENDPOINTS.BLOGS),
                    getData(API_ENDPOINTS.FILTER_NAVBAR_CATEGORIES),
                    getData(API_ENDPOINTS.FILTER_NAVBAR_TENDENCIES),
                ]);

                if (blogsResponse.status === 'fulfilled') setBlogs(blogsResponse.value.data);
                if (categoriesResponse.status === 'fulfilled') setCategories(categoriesResponse.value.data);
                if (navbarCategoriesResponse.status === 'fulfilled') setNavbarCategories(navbarCategoriesResponse.value.data);
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        const fetchSVG = async (url) => {
            try {
                const res = await fetch(url);
                if (!res.ok) throw new Error('Network response was not ok');
                const data = await res.text();
                setSvgContent(data);
            } catch (error) {
                console.error('Fetch SVG failed:', error);
            }
        };

        navBarData();
        fetchSVG('/assets/img/logo.svg').catch(() => fetchSVG('/logo.svg'));
    }, []);

    return (
        <InitialFetchContext.Provider value={{
            blogs,
            categories,
            navbarCategories,
            svgContent,
            loading,
            error
        }}>
            {children}
        </InitialFetchContext.Provider>
    );
};

export const useNavBar = () => useContext(InitialFetchContext);
